import React, { memo, useCallback } from 'react';
import { FileUploadSection, UploadFile } from '@/components/common/admin/mobile/FileUploadSection';
import { CreateResourceFormData, CreateResourceFormErrors } from '@/components/admin/resources/CreateResource/hooks/useCreateResourceForm';

// ResourceFile is now just an alias for UploadFile for backward compatibility
type ResourceFile = UploadFile;

interface ResourceFilesSectionProps {
  formData: CreateResourceFormData;
  errors: CreateResourceFormErrors;
  onFieldChange: (field: keyof CreateResourceFormData, value: UploadFile[]) => void;
  onAppendFiles?: (newFiles: ResourceFile[]) => void; // Optional for edit mode
}

export const ResourceFilesSection = memo<ResourceFilesSectionProps>(({
  formData,
  errors,
  onFieldChange,
  onAppendFiles,
}) => {
  const files = formData.files as ResourceFile[];

  const handleFilesChange = useCallback((newFiles: UploadFile[]) => {
    // Always use onFieldChange for file operations (both add and remove)
    // This ensures consistent behavior in both create and edit modes
    onFieldChange('files', newFiles);
  }, [onFieldChange]);

  return (
    <FileUploadSection
      title="Files"
      subtitle="Upload files to attach to your resource (optional)"
      files={files}
      onFilesChange={handleFilesChange}
      // Don't use onAppendFiles - let FileUploadSection handle everything through onFilesChange
      error={errors.files}
    />
  );
});

ResourceFilesSection.displayName = 'ResourceFilesSection';